import { NonInteractiveView } from '../../playerStore.types';
import { currentPin } from '../../playerStore.utils';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { sharedNonInteractiveReducer } from './sharedNonInteractiveReducer';

export const createNonInteractiveReducer: PlayerPinReducerFactory<NonInteractiveView> = () => nonInteractiveReducer;

const nonInteractiveReducer: PlayerPinReducer<NonInteractiveView> = {
  phases: sharedNonInteractiveReducer.phases,
  initial: (_state, lastKnownView) => sharedNonInteractiveReducer.initial(lastKnownView),
  hasNextView: (state, currentView, direction) =>
    sharedNonInteractiveReducer.hasNextView(currentPin(state), currentView, direction),
  handleNextView: (state, currentView, direction) =>
    sharedNonInteractiveReducer.handleNextView(currentPin(state), currentView, direction),
  onNextView: async () => null,
};
